import React, { FC } from 'react';
import styles from './FileUpload.module.scss';
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";

interface FileUploadProps {}

const FileUpload: FC<FileUploadProps> = () => (
  <div className={styles.FileUpload}>
      <div className={styles.MissionStatement}>
          <Helmet>
              <meta charSet="utf-8"/>
              <title>File Upload</title>
          </Helmet>
          <div className="standard-margin">
              <h1>Select Files</h1>
              <hr></hr>
              <p>

                  We now offer an easier way to archive your documents with eTIC (electronic-Technical Information Center).
                  If you have electronic copies of drawings or documents that fit the scope of TIC you can easily upload them for processing.

                  For Help using the File Uploader, visit the <Link to={"./../helppage"}>Help</Link> page.

              </p>
          </div>
      </div>
  </div>
);

export default FileUpload;
